exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".day-cell{flex:1;min-height:112px;padding:4px;border-right:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;background:hsla(0,0%,58%,.1)}.day-number{text-align:right;color:rgba(0,0,0,.25);font-size:1em;padding:5px}.current-month{background:#fff}.current-month p{color:rgba(0,0,0,.5);font-size:1.5em}.selected-day p{font-size:2.4em;font-weight:bolder}.weekend p{color:rgba(210,2,2,.6)}.today{background-color:#e8fde7}.today p{font-size:2em;font-weight:bolder;color:#367016}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-434dac4e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/Day.vue
// module id = 136
// module chunks = 0 1